<template>
  <div>功能2</div>
</template>
<script>
export default {
  name: 'Header',
  components: {
  },
  data(){
    return {
    }
  },
  created: function () {
  },
  computed: {
  },
  watch: {
  },
  mounted: function(){
    console.log('功能2 mounted')
  },
  destroyed: function(){
    console.log('功能2 destroyed')
  },
  methods: {
  },
}
</script>